import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Time from "../../../Time/Time";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { Attachment } from "../../Partials/Attachment/Attachment";
import * as uuidV4 from "uuid/v4";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { Admin } from "../../../Entity/Entities/Person/Role/Roles/Admin";
import { User } from "../../../Entity/Entities/Person/Role/Roles/User";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Constants from "../../../Action/Constants";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from "../../Partials/Material/Select";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import PersonCreateWillMount from "../../../Middleware/Middlewares/PersonCreateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { EntityAvatar } from "../../Partials/Avatar/EntityAvatar";

class UserCreate extends Component {
  public state = {
    firstName: "",
    lastName: "",
    email: "",
    role: String(User.contactRoleId),
    phone1: "",
    phone2: "",
    profession: "",
    address: {
      formattedAddress: "",
    },
    dateOfBirth: null,
    identityNumber: "",
    mainBankAccountId: "",
    mainBankAccountName: "",
    identityType: 255,
    company: {
      id: null,
      avatar: this.image.get("company")
    },
    amazonFolderName: uuidV4(),
    openLeavePrompt: false,
    note: "",
    hasModifiedData: false,
    emailNotValid: false,
    displayLess: true,
    displayMore: false,
    attachments: [],
    genderTypeId: 3,
    languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,

    personAddress: {
      formattedAddress: ""
    },
    documentAddress: {
      formattedAddress: "",
    },
    beta: false,
    placeOfBirthAddress: {
      formattedAddress: "",
    }
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTACT_PERSON_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PersonCreateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.save = this.save.bind(this);
  }

  public getPayload(): any {
    return {
      person: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        profession: this.state.profession,
        email: this.state.email,
        phone1: this.state.phone1,
        phone2: this.state.phone2,
        contactRoleId: Number(this.state.role),
        mainBankAccountId: this.state.mainBankAccountId,
        mainBankAccountName: this.state.mainBankAccountName,
        bankAccount: {
          accountId: this.state.mainBankAccountId,
          name: this.state.mainBankAccountName
        },
        companyId: this.state.company.id,
        address: { ...this.state.personAddress },
        dateOfBirth: Time.formatOrNull(this.state.dateOfBirth),
        placeOfBirth: this.state.placeOfBirthAddress,
        identityNumber: this.state.identityNumber,
        identityType: this.state.identityType,
        amazonFolderName: this.state.amazonFolderName,
        note: this.state.note,
        pageTemplate: "user",
        genderTypeId: this.state.genderTypeId,
        languageTypeId: this.state.languageTypeId,
        documentAddress: this.state.documentAddress
      }
    };
  }

  public save() {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: this.getPayload(),
        onSuccess: (person) => {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("system-sent-notification-to-new-user"),
              type: "info"
            }
          });

          if(this.state.beta){
            this.saving(() => {
              this.props.dispatch({
                type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START,
                payload: {
                  preferences: {
                    language: person &&
                              person.userSettings &&
                              person.userSettings.language &&
                              person.userSettings.language.iso,
                    locale:   person &&
                              person.userSettings &&
                              person.userSettings.locale &&
                              person.userSettings.locale.iso,
                    currency: person &&
                              person.userSettings &&
                              person.userSettings.currency &&
                              person.userSettings.currency.getCurrencyId(),
                    beta: this.state.beta,
                    userId: person?.id,
                  }
                },
                onSuccess: () => {
                  this.setState({
                    isSaving: false,
                    hasModifiedData: false
                  });
                },
                onError: () => {
                  this.setState({
                    isSaving: false,
                    hasModifiedData: true
                  });
                }
              });
            });
          }

          return this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public setEmail = (event) => {
    const email = event.target.value;

    this.setState({
      email: email,
      emailNotValid: false
    });
  }

  public changeRole = (event) => {
    const role = String(event.target.value);

    this.setState({role: role});
  }

  public selectCountry = (event) => {
    this.setState({
      hasModifiedData: true,
      documentAddress: event,
    })
  }

  public clearCountry = () => {
    this.setState({
      hasModifiedData: true,
      documentAddress: {
        formattedAddress: "",
      }
    })
  }

  public switchUsingBeta = () => {
    this.setState({
      beta: !this.state.beta
    });
  }

  public selectPlaceOfBirth = (event) => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: event,
    })
  }

  public clearPlaceOfBirth = () => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: {
        formattedAddress: "",
      }
    })
  }

  public render() {
    const radioButtonStyles = {
      width: "auto",
      marginRight: "0",
      minWidth: "155px",
      fontSize: "16px"
    };
    return (
      <div className="state-app">
        <div className="box box-full component-user-create has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("new-user")}</h1>
              <div className="button-container">
                <Button
                  color="primary"
                  onClick={this.cancel.bind(this)}
                  style={{marginRight: "20px"}}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              <Card className="card">
                <div className="grid align-icon-grid">
                  <EntityAvatar
                    {...this.props}
                    ref="EntityAvatar"
                    entityName="person"
                  />
                </div>
                <div className="grid">
                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-firstName"
                    type="text"
                    label={this.trans("label-first-name")}
                    value={this.state.firstName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                    autoFocus={true}
                    variant="standard"
                    error={!!this.getErrorFor("firstName")}
                  />
                  {!!this.getErrorFor("firstName") && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-lastName"
                    type="text"
                    label={this.trans("label-last-name") + this.trans("field/optional")}
                    value={this.state.lastName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                    variant="standard"
                    error={!!this.getErrorFor("lastName")}
                  />
                  {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-email"
                    label={this.trans("label-email")}
                    value={this.state.email}
                    onChange={this.setEmail}
                    variant="standard"
                    error={!!this.getErrorFor("email")}
                  />
                  {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

                  <div className="filters-wrapper" style={{
                    display: "flex",
                    marginBottom: "10px"
                  }}>
                    <RadioGroup
                      name="roleFilters"
                      value={String(this.state.role)}
                      onChange={this.changeRole}
                      style={{
                        display: "flex",
                        flexDirection: "row"
                      }}
                    >
                      <FormControlLabel
                        value={String(User.contactRoleId)}
                        label={this.trans("role-manager")}
                        style={radioButtonStyles}
                        control={<Radio color="primary" />}
                      />
                      <FormControlLabel
                        value={String(Admin.contactRoleId)}
                        label={this.trans("role-admin")}
                        style={radioButtonStyles}
                        control={<Radio color="primary" />}
                      />
                    </RadioGroup>
                  </div>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.beta}
                        onChange={this.switchUsingBeta}
                        color="primary"
                      />
                    }
                    label={this.trans("use-beta-version-features")}
                  />

                  <div style={{margin: "-10px 0"}}>
                    <TextField
                      autoComplete="off"
                      className="form-element half-size scroll-to-phone1 textfield-width-half"
                      type="text"
                      label={this.trans("label-mob-number") + this.trans("field/optional")}
                      value={this.state.phone1}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                      variant="standard"
                      error={!!this.getErrorFor("phone1")}
                    />
                    {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}

                    <TextField
                      autoComplete="off"
                      className="form-element half-size scroll-to-phone2 textfield-width-half"
                      type="text"
                      label={this.trans("other-phone") + this.trans("field/optional")}
                      value={this.state.phone2}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone2")}
                      variant="standard"
                      error={!!this.getErrorFor("phone2")}
                    />
                    {!!this.getErrorFor("phone2") && <div className="component-error-text">{this.getErrorFor("phone2")}</div>}
                  </div>

                  {this.state.displayLess && (
                    <Button
                      color="primary"
                      onClick={() => this.setState({displayMore: true, displayLess: false})}
                      style={{width: "100%", margin: "10px 0 10px 0"}}
                    >
                      {this.trans("button-show-more")}
                    </Button>
                  )}

                  {this.state.displayMore && (
                    <div>
                      <Select
                        className="form-element full-size form-input scroll-to-genderTypeId correct-label-position"
                        variant="standard"
                        error={this.getErrorFor("genderTypeId")}
                        value={this.state.genderTypeId}
                        onChange={this.sync.bind(this, this.syncronizers.GENDER_TYPE)}
                        htmlFor="genderType"
                        label={this.trans("gender-type") + this.trans("field/optional")}
                        name="genderType" 
                        id="genderType"
                      >
                        {this.getGenderTypeSelectboxes()}
                      </Select>

                      <Select
                        className="form-element full-size form-input scroll-to-languageTypeId correct-label-position"
                        variant="standard"
                        error={this.getErrorFor("languageTypeId")}
                        value={this.state.languageTypeId}
                        onChange={this.sync.bind(this, this.syncronizers.LANGUAGE_TYPE)}
                        htmlFor="languageType"
                        label={this.trans("language-type") + this.trans("field/optional")}
                        name="languageType" 
                        id="languageType"
                      >
                        {this.getLanguageTypeSelectboxes()}
                      </Select>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-profession"
                        type="text"
                        label={this.trans("profession") + this.trans("field/optional")}
                        value={this.state.profession}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "profession")}
                        variant="standard"
                        error={!!this.getErrorFor("profession")}
                      />
                      {!!this.getErrorFor("profession") && <div className="component-error-text">{this.getErrorFor("profession")}</div>}

                      <DatePickerComponent
                        {...this.props}
                        className="scroll-to-dateOfBirth"
                        label={this.trans("date-of-birth") + this.trans("field/optional")}
                        initialDate={this.state.dateOfBirth}
                        onChange={date => this.setState({ dateOfBirth: date, hasModifiedData: true })}
                        clearButton={true}
                        error={this.getErrorFor("dateOfBirth")}
                      />

                      <AddressSelector
                        {...this.props}
                        // id="address"
                        // name="address.googlePlaceId"
                        className="scroll-to-documentAddress"
                        labelText={this.trans("place-of-birth") + this.trans("field/optional")}
                        searchText={this.state.placeOfBirthAddress.formattedAddress ? this.state.placeOfBirthAddress.formattedAddress : null}
                        selectedAddress={this.state.placeOfBirthAddress}
                        onSelect={this.selectPlaceOfBirth}
                        onClear={this.clearPlaceOfBirth}
                        //countryList={true}
                        error={this.getErrorFor("placeOfBirth")}
                      />

                      <Select
                        className="form-element full-size form-input scroll-to-identityType correct-label-position"
                        error={this.getErrorFor("identityType")}
                        variant="standard"
                        value={this.state.identityType}
                        onChange={this.sync.bind(this, this.syncronizers.IDENTITY_TYPE)}
                        htmlFor="identityDocumentType"
                        label={this.trans("identity-document-type") + this.trans("field/optional")}
                        name="identityDocumentType" 
                        id="identityDocumentType"
                      >
                        {this.getIdentityTypeSelectboxes()}
                      </Select>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-identityNumber"
                        type="text"
                        label={this.trans("identity-document-number") + this.trans("field/optional")}
                        value={this.state.identityNumber}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "identityNumber")}
                        variant="standard"
                        error={!!this.getErrorFor("identityNumber")}
                      />
                      {!!this.getErrorFor("identityNumber") && <div className="component-error-text">{this.getErrorFor("identityNumber")}</div>}

                      <AddressSelector
                        {...this.props}
                        // id="address"
                        // name="address.googlePlaceId"
                        className="scroll-to-documentAddress"
                        labelText={this.trans("dropdown/documentcountry-label") + this.trans("field/optional")}
                        searchText={this.state.documentAddress.formattedAddress ? this.state.documentAddress.formattedAddress : null}
                        selectedAddress={this.state.documentAddress}
                        onSelect={this.selectCountry}
                        onClear={this.clearCountry}
                        countryList={true}
                      />

                      <AddressSelector
                        {...this.props}
                        id="address"
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        searchText={this.state.personAddress.formattedAddress ? this.state.personAddress.formattedAddress : null}
                        selectedAddress={this.state.personAddress}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "personAddress")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "personAddress", {})}
                      />

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-mainBankAccountId"
                        type="text"
                        label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                        value={this.state.mainBankAccountId}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountId")}
                        variant="standard"
                        error={!!this.getErrorFor("bankAccount.accountId")}
                        helperText={this.getErrorFor("bankAccount.accountId")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="mainBankAccountName"
                        // name="mainBankAccountName"
                        className="form-element full-size scroll-to-mainBankAccountName"
                        type="text"
                        label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                        value={this.state.mainBankAccountName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                        variant="standard"
                        error={!!this.getErrorFor("mainBankAccountName")}
                        helperText={this.getErrorFor("mainBankAccountName")}
                      /> 
                      
                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                      />
                      {!!this.getErrorFor("note") && <div className="component-error-text">{this.getErrorFor("note")}</div>}

                      <Button
                        color="primary"
                        onClick={() => this.setState({displayMore: false, displayLess: true})}
                        style={{width: "100%", margin: "10px 0 10px 0"}}
                      >
                        {this.trans("button-show-less")}
                      </Button>
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </div>

          <div className="component-wrapper">
            <Attachment
              {...this.props}
              possibilityToSetAvatar={true}
              typeOfComponent="shared"
              title={this.trans("attachments-for-user")}
              relation="contactId"
              onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
              amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
              attachments={this.state.attachments}
              updateParentState={attachments => this.setState({attachments: attachments})}
              onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
              onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            />
          </div>
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.personCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps, null, null, { withRef: true })(
    UserCreate
);
